// src/config/entitlements.js

// 1. Define packages (ONLY TWO)
export const PACKAGES = {
  FREE: "FREE",
  PRO: "PRO",
};

// 2. Define all features
export const FEATURES = {
  DASHBOARD_TASKS: "DASHBOARD_TASKS",
  HABIT_TRACKER: "HABIT_TRACKER",
  GOAL_TRACKER: "GOAL_TRACKER",
  WORK_HOURS: "WORK_HOURS",
  FINANCE_TRACKER: "FINANCE_TRACKER",
  STREAKS: "STREAKS",
  DASHBOARD_REMINDERS: "DASHBOARD_REMINDERS",
  ANALYTICS: "ANALYTICS",
  GROWTH: "growth", // Add this line
};

// 3. Entitlements
export const ENTITLEMENT_MAP = {
  // FREE = old FREE + old GOLD
  [PACKAGES.FREE]: [
    FEATURES.DASHBOARD_TASKS,
    FEATURES.HABIT_TRACKER,
    // FEATURES.GOAL_TRACKER,
    FEATURES.FINANCE_TRACKER,
    FEATURES.WORK_HOURS,
    FEATURES.DASHBOARD_REMINDERS,
    FEATURES.ANALYTICS,
    // FEATURES.GROWTH, // Add this line
  ],

  // PRO = EVERYTHING (old FULL_OPTION)
  [PACKAGES.PRO]: Object.values(FEATURES),
};

// 4. Access helper
export function canAccessFeature(userTier, featureKey) {
  if (!ENTITLEMENT_MAP[userTier]) return false;
  return ENTITLEMENT_MAP[userTier].includes(featureKey);
}
